import { render } from "./RegisterOrder.vue?vue&type=template&id=7667d676&scoped=true&ts=true"
import script from "./RegisterOrder.vue?vue&type=script&lang=ts"
export * from "./RegisterOrder.vue?vue&type=script&lang=ts"

import "./RegisterOrder.vue?vue&type=style&index=0&id=7667d676&scoped=true&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7667d676"]])

export default __exports__